import React, {useState} from 'react';
import Table from "../../../components/Table";
import moment from "moment";
import ResourceDetail from "./detail";
import {Button} from "antd";
import {PlusOutlined, CopyOutlined} from "@ant-design/icons";

const ResourceTable = () => {

    const [detailId, setDetailId] = useState(null);
    const [copyId, setCopyId] = useState(null);
    const [toggleReloadState, setToggleReloadState] = useState(null);

    const toggleReload = () => {
        setToggleReloadState(Math.random(5));
    };

    const closeDetail = () => {
        setDetailId(null);
        setCopyId(null);
        toggleReload();
    };



    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Erstellt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: true,
            render: (data) => `${moment(data).format('DD.MM.YYYY HH:mm')} Uhr`
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            sorter: false,
            render: (data) => <CopyOutlined onClick={(e) => {  e.preventDefault(); e.stopPropagation(); setCopyId(data); setDetailId('new') }} />
        }

    ];

    return (<>
            <ResourceDetail
                id={detailId}
                close={closeDetail}
                copyId={copyId}
            />

            <div style={{marginBottom: '15px', textAlign: 'right'}}>
                <Button
                    type={"primary"}
                    icon={<PlusOutlined />}
                    onClick={() => setDetailId("new")}
                >
                    Hinzufügen
                </Button>
            </div>

            <Table
                endpoint={'resource'}
                columns={columns}
                sortField={'createdAt'}
                sortOrder={'descend'}
                onClick={(record) => setDetailId(record.id)}
                toggleReload={toggleReloadState}
            />
        </>
    );
}

export default ResourceTable;
